import RefreshIcon from '@mui/icons-material/Refresh';

import { useTranslate } from '../../../../../../../../../../hooks/useTranslate';
import { Button } from '../../../../../../../../../Button/Button';
import { ButtonWrapper, Explainer } from '../../Message.styles';

type Props = {
  onTryAgainClicked: () => void;
};

export const ServerError = ({ onTryAgainClicked }: Props) => {
  const { t } = useTranslate();

  return (
    <>
      {t('explore.amelia.serverErrorMessage')}
      <ButtonWrapper>
        <Button variant="secondary" format="block" onClick={onTryAgainClicked}>
          {t('explore.amelia.tryAgainButton.label')}
          <RefreshIcon />
        </Button>
      </ButtonWrapper>

      <Explainer>{t('explore.amelia.explainer')}</Explainer>
    </>
  );
};
